import { React, PT } from '@gasbuddy/react';
import moment from 'moment';
import { Table } from 'semantic-ui-react';

export const ZdTable = ({ tickets, onSelected }) => {
  if (!tickets) {
    return null;
  }

  return (
    <Table basic="very" selectable style={{ tableLayout: 'fixed', fontSize: '0.9em' }}>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={2}>ID</Table.HeaderCell>
          <Table.HeaderCell>Subject</Table.HeaderCell>
          <Table.HeaderCell width={2}>Requested</Table.HeaderCell>
          <Table.HeaderCell width={2}>Updated</Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {tickets.map(a => (
          <Table.Row
            key={a.id}
            onClick={() => onSelected(a)}
          >
            <Table.Cell>
#
              {a.id}
            </Table.Cell>
            <Table.Cell>{a.subject}</Table.Cell>
            <Table.Cell>{moment().to(a.created_at)}</Table.Cell>
            <Table.Cell>{moment().to(a.updated_at)}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

ZdTable.propTypes = {
  tickets: PT.arrayOf(PT.shape({
    id: PT.number.isRequired,
    subject: PT.string.isRequired,
  })),
  onSelected: PT.func.isRequired,
};

ZdTable.defaultProps = {
  tickets: [],
};
